import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useTheme, useMediaQuery } from "@mui/material";
import ProductImageGallery from "../../components/ProductImageGallery";

const LeftColumn = ({
  selectedImage,
  setSelectedImage,
  secondaryImages,
  handleAddToCart,
  priceLoading,
  totalPrice,
  selectedSize,
  selectedFlavor,
  customizations = {},
  cake,
}) => {
  const [pulse, setPulse] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const allImages = [cake.images.primary, ...(cake.images.secondary || [])];

  const isNumberCake = cake?.name === "number_cake";
  const characters = customizations.characters || [];
  const hasValidCharacters =
    !isNumberCake ||
    (Array.isArray(characters) &&
      characters.some((c) => typeof c?.char === "string" && c.char.trim()));

  const isDisabled =
    !selectedSize || !selectedFlavor || priceLoading || !hasValidCharacters;

  useEffect(() => {
    setPulse(true);
    const timeout = setTimeout(() => setPulse(false), 300);
    return () => clearTimeout(timeout);
  }, [totalPrice]);

  useEffect(() => {
    if (cake?.images?.primary) {
      setSelectedImage(cake.images.primary);
    }
  }, [cake]);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 100,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      <Box sx={{ width: "100%", mb: 2 }}>
        <ProductImageGallery
          images={allImages}
          productName={cake.displayName}
          selectedIndex={selectedIndex}
          onIndexChange={(index) => {
            setSelectedIndex(index);
            setSelectedImage(allImages[index]); // this is now stable
          }}
          fullScreenOpen={fullscreenOpen}
          setFullScreenOpen={setFullscreenOpen}
          thumbnailPosition="right"
          mainImageStyles={{
            borderRadius: 2,
            objectFit: "contain",
            maxHeight: 600,
          }}
          thumbnailStyles={{
            height: isMobile ? 60 : 100,
            width: isMobile ? 60 : 100,
            objectFit: "cover",
            maxHeight: 500,
          }}
          thumbnailContainerStyles={{
            maxHeight: 400,
          }}
        />
      </Box>

      {!isMobile && (
        <>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            startIcon={<ShoppingBagIcon />}
            onClick={handleAddToCart}
            disabled={isDisabled}
            sx={{
              mt: 3,
              py: 1.5,
              fontWeight: 600,
              fontSize: "1rem",
              borderRadius: "12px",
              "&:hover": { backgroundColor: "#e86b5e" },
              animation: pulse ? "pulse 0.3s ease" : "none",
              "@keyframes pulse": {
                "0%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.03)" },
                "100%": { transform: "scale(1)" },
              },
            }}>
            {priceLoading
              ? "Calculating..."
              : `Add to Cart ($${totalPrice.toFixed(2)})`}
          </Button>

          {isDisabled && !priceLoading && (
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                color: "#999",
                textAlign: "center",
                display: "block",
                fontStyle: "italic",
              }}>
              {isNumberCake && !hasValidCharacters
                ? "Please choose size, flavor, and enter at least one character"
                : "Make your selections on the right to enable this button"}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default LeftColumn;
